import { Breed } from './cycle.model';

export const BREEDS: Breed[] = [
  {
    id: 1,
    name: 'Ross 708',
  },
  {
    id: 2,
    name: 'Ross 308 SF',
  },
  {
    id: 3,
    name: 'Cobb 500 FF',
  },
  {
    id: 4,
    name: 'Cobb 500 SF',
  },
  {
    id: 5,
    name: 'Hubbard JA 57',
  },
  {
    id: 6,
    name: 'Hubbard JA 87',
  },
  {
    id: 7,
    name: 'Hubbard M 22',
  },
  {
    id: 8,
    name: 'Hubbard M 77',
  },
  {
    id: 9,
    name: 'Ranger Classic',
  },
  {
    id: 10,
    name: 'Ranger Gold',
  },
  {
    id: 11,
    name: 'Ross 308 FF',
  },
  {
    id: 12,
    name: 'Hubbard Redbro',
  },
  {
    id: 13,
    name: 'Rustic Gold',
  },
  {
    id: 14,
    name: 'TPA',
  },
  {
    id: 15,
    name: 'Rowan Rustic',
  },
  {
    id: 999,
    name: 'Diversen',
  },
];
